module.exports = __webpack_public_path__ + "img/capital.95a0a36.png";